import{styled as e}from"@mui/material/styles";const t=e("img")((({ownerState:e,theme:t})=>({display:"block",maxWidth:"100%",borderRadius:8,..."desktop"!==e.screenSize&&{margin:t.spacing(0,"auto",3)}})));export{t as Image};
//# sourceMappingURL=styles.js.map
